import React, { useRef } from 'react';
import { Pie, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const EmployeeCountPiaChart = ({ peopleOverViewData, duration, setSelectedRange, getEmployees }: any) => {
    const colors = ['#51A2FF', '#05DF72'];
    const labels = peopleOverViewData?.employeeChartData?.labels || [];
    const chartRef = useRef<any | null>(null);
    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Employees',
                data: peopleOverViewData?.employeeChartData?.counts,
                backgroundColor: colors,
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom' as const,
                labels: {
                    padding: 19,
                    boxWidth: 6,
                    boxHeight: 6,
                    usePointStyle: true,
                    pointStyle: 'circle',
                    font: {
                        size: 13,
                    },
                },
            },
        },
    };
    const handleClick = (event: any) => {
        const eventData = getElementAtEvent(chartRef.current, event);
        if (!eventData.length) return;

        const index = eventData[0].index;
        const label = labels[index];

        setSelectedRange({ type: label });
        let query = `?page=0&limit=10`;

        query += `&type=${label}`;

        getEmployees(query, `${label} Employees`, { type: label });
    };
    return (
        <div className="w-full h-full flex flex-col items-center">
            <div className="flex justify-between max-md:flex-col max-md:gap-[10px] w-full">
                <div className="flex items-center">
                    <h2 className="text-black text-sm font-black">All Employees</h2>
                </div>
            </div>
            <div className="relative w-full h-[320px] p-3 max-md:mt-[5px] mt-[15px]">
                <Pie data={data} ref={chartRef} options={options} onClick={handleClick} />
            </div>
        </div>
    );
};

export default EmployeeCountPiaChart;
